import { RetailPlaceAddress } from './new-retail-place.model';

export const DEFAULT_RETAIL_PLACE_ADDRESS: RetailPlaceAddress = {
  regionCode: null,
  city: null,
  area: null,
  localityId: null,
  apartment: null,
  geonimId: null,
  postalCode: '',
  house: null,
  fullAddress: '',
  settlement: '',
  region: null,
  street: null,
  regionId: null,
  buildingId: null,
  rca: null,
};
